import { finance } from "../data";
import { adjustSound } from "./adjustSound";
import { createButton } from "./createButton";
/** @param {Phaser.Scene} scene*/
export const createPause = (scene, scaleX, callback) => {
  let pause = scene.add
    .image(50 * scaleX, 50 * scaleX, "pause")
    .setScale(0.1 * scaleX)
    .setInteractive()
    .on("pointerover", () => {
      pause.setTint(0xb0adad);
    })
    .on("pointerout", () => {
      pause.setTint(0xffffff);
    })
    .on("pointerdown", () => {
      callback();
    });
  return pause;
};

/**
 * @param {Phaser.Scene} scene
 * @param {Phaser.Physics.Arcade.Sprite} character
 */
export const handlePauseMenu = (
  scene,
  character,
  readyToJump,
  width,
  height,
  scaleX,
  callbackSound,
  callbackResume
) => {
  const midWidth = width / 2;
  const midHeight = height / 2;
  const container = scene.physics.add.group([]);
  if (readyToJump) {
    if (finance.skinned) {
      character.setTexture("skinnedIdle");
    } else {
      character.setTexture("idle");
    }
  }
  const bambooFrame = scene.add
    .image(midWidth, midHeight, "bambooFrame")
    .setDisplaySize(width * 0.9, height * 0.6);
  const gamePaused = scene.add
    .text(midWidth, midHeight - 90 * scaleX, "Game Paused", {
      fontFamily: "Grooving",
      fontStyle: "italic",
      fontSize: "80px",
      color: "#323232",
      letterSpacing: "30px",
    })
    .setScale(scaleX)
    .setOrigin(0.5);
  const { soundAssets } = adjustSound(
    scene,
    width / 4,
    height / 2.1,
    Math.sqrt(scene.sound.volume) //as it is power 2 in the adjust sound
  );
  /** @type {Phaser.GameObjects.Image} */
  const exit = createButton(
    scene,
    midWidth - 50 * scaleX,
    midHeight + 50 * scaleX,
    "exit",
    0.4 * scaleX,
    () => {
      callbackSound();
    }
  );
  exit.setOrigin(1, 0.5);
  /** @type {Phaser.GameObjects.Image} */
  const resume = createButton(
    scene,
    midWidth + 50 * scaleX,
    midHeight + 50 * scaleX,
    "resume",
    0.4 * scaleX,
    () => {
      container.setVisible(false);
      container.setActive(false);
      soundAssets.setVisible(false);
      callbackResume();
    }
  );
  resume.setOrigin(0, 0.5);
  container.addMultiple([bambooFrame, gamePaused, exit, resume]);
};
